import { useState } from "react";
import type { PreferredSlot } from "@/lib/demoRequest";
import { Button } from "./Button";
import { cn } from "@/lib/cn";

const fieldCls =
  "rounded-lg border border-border bg-background px-3 py-2 text-sm text-foreground focus:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-ring/40";

export function SlotPicker({
  value,
  onChange,
  tz,
}: {
  value: PreferredSlot[];
  onChange: (slots: PreferredSlot[]) => void;
  tz: string;
}) {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const full = value.length >= 3;

  function add() {
    if (!date || !time || full) return;
    onChange([...value, { date, time, tz }]);
    setDate("");
    setTime("");
  }

  function remove(i: number) {
    onChange(value.filter((_, idx) => idx !== i));
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap items-end gap-3">
        <label className="flex flex-col gap-1 text-xs text-muted-foreground">
          Date
          <input type="date" className={fieldCls} value={date} onChange={(e) => setDate(e.target.value)} />
        </label>
        <label className="flex flex-col gap-1 text-xs text-muted-foreground">
          Time
          <input type="time" className={fieldCls} value={time} onChange={(e) => setTime(e.target.value)} />
        </label>
        <Button type="button" variant="ghost" onClick={add} className={cn(full && "opacity-50")} disabled={full}>
          Add slot
        </Button>
      </div>
      <p className="font-mono text-xs text-muted-foreground">
        {value.length}/3 preferred slots · timezone {tz}
      </p>
      <ul className="flex flex-col gap-2">
        {value.map((s, i) => (
          <li key={`${s.date}-${s.time}-${i}`} className="flex items-center justify-between rounded border border-border px-3 py-2 text-sm">
            <span className="font-mono">{s.date} {s.time} ({s.tz})</span>
            <button type="button" onClick={() => remove(i)} className="text-muted-foreground hover:text-signal" aria-label={`Remove ${s.date} ${s.time}`}>
              ✕
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
